<template>
  <div class="sign-detail" :class="{'filter-blur':activitymoadal==true}">
      <div class="tab-title">
          <div class="back-sign" @click="backSign" v-show="finish == 1"><<返回点名</div>
          <div class="sign-tab">
            <div class="sign-in" :class="type=='1'?'active':''" @click="changeTab('1')"><span>已签到</span><span>&nbsp;{{signedNum}}</span></div>
            <div class="sign-out" :class="type=='2'?'active':''" @click="changeTab('2')"><span>未签到</span><span>&nbsp;{{unSignNum}}</span></div>
          </div>
      </div>
      <div class="tab-content" v-scrollBar ref="voteDetial">
          <div class="content-sign-in" v-show="type=='1'" ref="signInHeight">
              <div class="sign-in-item" v-for="(item,index) in signedUsers" :key="index">
                  <div class="img">
                    <img v-if="item.headImage" :src="getImg(item.headImage)" alt="">
                    <img v-if="!item.headImage" src="../../common/img/wo_nohead.png" alt="">
                  </div>
                  <span class="name" title="item.name">{{item.name}}</span>
              </div>
              <div class="no-signed" v-if="signedUsers.length==0">
                    暂时还没有学生签到
              </div>
          </div>
          <div class="content-sign-out" v-show="type=='2'" ref="signOutHeight">
                <div class="sign-out-item animated fadeIn" v-for="(item,index) in unSignUsers" :key="index">
                  <div class="img">
                    <img v-if="item.headImage" :src="getImg(item.headImage)" alt="">
                    <img v-if="!item.headImage" src="../../common/img/wo_nohead.png" alt="">
                  </div>
                  <span class="name" title="item.name">{{item.name}}</span>
                </div>
                <div class="no-notsigned" v-if="unSignUsers.length==0">
                    学生已全部签到
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import EventHandler from '../../common/js/EventHandler'
export default {
  name: 'signDetail',
  props:{activitymoadal:Boolean},
  data () {
    return {
        type:'1',
        signedUsers:[],//已签到列表
        unSignUsers:[],
        signedPageNum:1,
        unsignPageNum:1,
        timer:null,
        signedNum:0,
        unSignNum:0,
        allSignedUsers:[],
        allUnsignUsers:[],
        finish:1,
        userId:0,
        attendanceID:0,
    }
  },
  methods:{
   changeTab:function(type){
      clearInterval(this.timer);   
      this.timer = null;
       this.type = type;
       if(type == 1){
           this.getAllSignedDetial()
       }else{
           this.getAllUnsignDetial()
       }
       this.scroll();
   },
   backSign:function(){
       this.$router.replace({path: '/screenIndex/signIn'})
   },
   scroll:function(){
       this.$refs['voteDetial'].addEventListener('scroll', this.scrollFn)
   },
   scrollFn:function(){
        var scrollEl = this.$refs['voteDetial'];
        if(this.type == 1){
            var contentHeight = this.$refs['signInHeight'];
            if (scrollEl.scrollTop + scrollEl.offsetHeight > contentHeight.offsetHeight-20) {
                this.signedPageNum++
                if(this.finish==0){
                  this.signedUsers = this.allSignedUsers.slice(0,this.signedPageNum*21)       
                }
                if(this.signedUsers.length == this.allSignedUsers.length){
                    this.$refs['voteDetial'].removeEventListener('scroll', this.scrollFn)
                }
            }
        }else{
            var contentHeight = this.$refs['signOutHeight'];
            if (scrollEl.scrollTop + scrollEl.offsetHeight > contentHeight.offsetHeight-20) {
                this.unsignPageNum++
                if(this.finish == 0){
                this.unSignUsers = this.allUnsignUsers.slice(0,this.unsignPageNum*21)
                }
                if(this.unSignUsers.length == this.allUnsignUsers.length){
                    this.$refs['voteDetial'].removeEventListener('scroll', this.scrollFn)
                }
            }
        }        
   },
   getSignedDetialApi:function(pn,ps){
       var that = this;
       that.$http.get(that.baseURL1+'/newAttendance/getNewAttendanceDetail/'+this.attendanceID+'/'+1+'/'+pn+'?pageSize='+ps).then((res)=>{
           var data = res.data;
           that.signedNum = data.absenceNum;
           that.unSignNum = data.notAbsenceNum;
           data.title = data.title;
           //将title等传给父路由
           if(!data.title){
               data.title = that.common.getLocalTime(data.createDate)+'点名'
           }
           that.$emit('pushDetial',data)         
           that.allSignedUsers = data.users;
           that.signedUsers = that.allSignedUsers.slice(0,that.signedPageNum*21)     
           that.finish = data.finish;    
        //    if(data.finish == 0){
        //     clearInterval(that.timer)
        //     that.timer = null;
        //   }
       })
   },
   getUnsignDetialApi:function(pn,ps){
       var that = this;
       that.$http.get(that.baseURL1+'/newAttendance/getNewAttendanceDetail/'+this.attendanceID+'/'+0+'/'+pn+'?pageSize='+ps).then((res)=>{
           var data = res.data;
           that.signedNum = data.absenceNum;
           that.unSignNum = data.notAbsenceNum;  
           data.title = data.title; 
           if(!data.title){
               data.title = that.common.getLocalTime(data.createDate)+'点名'
           }
          //将title等传给父路由
           that.$emit('pushDetial',data)          
           that.allUnsignUsers = data.users;
           that.unSignUsers = that.allUnsignUsers.slice(0,that.unsignPageNum*21)
           that.finish = data.finish;
        //    if(data.finish == 0){
        //     clearInterval(that.timer)
        //     that.timer = null;
        //   }
       })
   },
   getImg(imgUrl){
      return this.common.handleImg(imgUrl,this.rescourceURL);
   },
   getAllSignedDetial:function(){
      var that = this;
      this.timer = setInterval(function() {
         that.getSignedDetialApi(1,9999)
      }, 2000)
   },
   getAllUnsignDetial:function(){
      var that = this;
      this.timer = setInterval(function() {
         that.getUnsignDetialApi(1,9999)
      }, 2000)
   },
   _changeTab:function(param){
       if(param == 1){
           this.changeTab('2')
       }else{
           this.changeTab('1')
       }
   }
  },
  computed:{

  },
  mounted:function(){
      this.scroll()
  },
  created:function(){
      EventHandler.bindEvent('changeTab',this._changeTab)
      this.type = this.$route.query.type;
      this.userId = this.common.getCookie('userId')
      this.attendanceID = this.common.getCookie('activityId')
      this.getSignedDetialApi(1,9999)
      this.getUnsignDetialApi(1,9999)
      if(this.type == 1){
          this.getAllSignedDetial()
      }else{
          this.getAllUnsignDetial()
      }
  },
  watch:{
  },
  beforeDestroy() {
    clearInterval(this.timer);        
    this.timer = null;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'signDetail.scss'
</style>



// WEBPACK FOOTER //
// src/components/signDetail/signDetail.vue